import React from "react";
import { Link } from "react-router-dom";

const Games: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">
          Our Games
        </h1>

        <div className="space-y-8">
          {/* Vorld Game Description */}
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-4 text-blue-600">Vorld</h2>
            <p className="text-gray-700 leading-relaxed">
              Vorld is an experimental exploration experience. It's currently an
              empty void, a canvas for you to wander around in. Who knows, you
              might find some hidden secrets lurking in the expanse! Keep an eye
              out for future updates as we build out this world.
            </p>
            <div className="mt-4">
              <Link
                to="/"
                className="inline-block bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Find Vorld Lobbies
              </Link>
            </div>
          </div>

          {/* Rock Paper Scissors Game Description */}
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-4 text-green-600">
              Rock Paper Scissors
            </h2>
            <p className="text-gray-700 leading-relaxed">
              The classic game of strategy and chance! Challenge other players
              to a match of Rock Paper Scissors. Will your choice triumph over
              theirs? Simple, fast, and fun.
            </p>
            <div className="mt-4">
              <Link
                to="/"
                className="inline-block bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Find RPS Lobbies
              </Link>
            </div>
          </div>

          {/* Add more game descriptions here */}
        </div>
      </div>
    </div>
  );
};

export default Games;
